import gql from 'graphql-tag';

export default gql`
  query getPracticalInfo {
    getPracticalInfo {
      id
      header_desktop
      header_mobile
      visual_desktop
      visual_mobile
      push_bg_desktop
      push_bg_mobile
      access_desktop
      access_mobile
      tt_hours
      tt_all_days
      tt_text_open
      tt_text_close
      details {
        id
        title
        opening
        closing_time
        push_cta_label
        push_cta_url
        section_instagram_title
        language_code
        meta_title
        meta_description
        meta_tags
        meta_og_title
        meta_og_description
        meta_og_url
      }
      updated_at
    }
  }
`;



// WEBPACK FOOTER //
// ./src/apollo/graphql/practicalInfo/get.js